import { render, staticRenderFns } from "./ForecastSelector.vue?vue&type=template&id=bf01d5c4&scoped=true"
import script from "./ForecastSelector.vue?vue&type=script&lang=js"
export * from "./ForecastSelector.vue?vue&type=script&lang=js"
import style0 from "./ForecastSelector.vue?vue&type=style&index=0&id=bf01d5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf01d5c4",
  null
  
)

export default component.exports